import { watch, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { FouSelectObject } from 'src/utils/objects/fou-select'
import { getFoundrySubTitle, attemptFoundrySwitch } from 'src/utils/helper/contractTermination'
import VSelect from 'components/form/v-select/index.vue'
export default{
  components:{
    VSelect
  },
  setup(){
    const store = useStore()

    const foundriesOptions = ref(FouSelectObject())
    const allFoundries = computed(() => store.getters['profile/foundries'])
    const sessionFoundryId = computed(() => store.getters['profile/sessionFoundryId'])
    const sessionFoundryName = computed(() => store.getters['profile/sessionFoundryName'])
    const defaultFoundry = computed(() => store.getters['profile/defaultFoundry'])
    const foundries = computed(() => allFoundries.value?.filter((foundry) => foundry.permissions.length > 0))
    
    /**
     * Set foundries dropdown options, and set the initially selected foundry
     */
    const init = () => {
      setFoundryOptions()
    
      const initialSelectedFoundryOption = chooseInitialSelectedFoundry()
      foundriesOptions.value.setValues({
        obj: [initialSelectedFoundryOption],
        value: 'value',
        name: 'label'
      })
    }
    
    /**
     * Set foundries options if foundries are avaliable in store
     */
    const setFoundryOptions = () => {
      const enriched = (foundries.value || []).map(f => ({
        ...f,
        subTitle: getFoundrySubTitle(f.contractStatus)
      }))
      foundriesOptions.value.setOptions({
        obj: enriched,
        value: 'id',
        name: 'name',
        multiple: true
      })
    }
    
    /**
     * Set initial value of dropdown based on foundry in session, default foundry selection
     * or the first foundry from the foundries list
     * 
     * @returns {{value: string, label: string}} Option to be set as selected foundry
     */
    const chooseInitialSelectedFoundry = () => {
      if (sessionFoundryId.value) {
        return {
          value: sessionFoundryId.value,
          label: sessionFoundryName.value
        }
      }
    
      if (defaultFoundry.value) {
        return {
          value: defaultFoundry.value.id,
          label: defaultFoundry.value.name
        }
      }
    
      return {
        value: foundries.value?.[0]?.id,
        label: foundries.value?.[0]?.name
      }
    }
    
    /**
     * Update current foundry id and name in session whenever user 
     * select a foundry from dropdown
     */
    const updateSessionFoundry = () => {
      if (foundriesOptions.value.values.value) {
        store
          .dispatch('auth/setSessionFoundry', {
            id: foundriesOptions.value.values.value,
            name: foundriesOptions.value.values.label
          })
          .then(() => {
            store.commit('profile/setFoundrySessionName')
            store.commit('profile/setFoundrySessionId')
          })
      }
    }
    ////WatchEffect is not working as expected
    watch(() => foundries, init, { immediate: true })
    
    const handleFoundryChange = (newVal, oldVal) => {
      if (newVal?.value) {
        if (newVal.value === sessionFoundryId.value) return
        if (attemptFoundrySwitch({
          foundryId: newVal.value,
          isUserAdmin: store.getters['auth/isUserAdmin'],
          store,
          revertSelection: () => { foundriesOptions.value.values = oldVal }
        })) return
        updateSessionFoundry()
      }
    }
    watch(() => foundriesOptions.value.values, handleFoundryChange)

    return{
      foundriesOptions,
      sessionFoundryId,
      foundries
    }
  }
}
